import { useContext } from 'react';
import WidgetContext from './WidgetContext';
import { sum, filter, concat, includes, find } from 'lodash';
import Image from 'next/image';
import {
    calculateTotalCount,
} from './utils';

import { toMoney, toPercent, optimizeImage } from './filters';
import CheckoutSummary from './CheckoutSummary';


export default function ProductSelector({ activeTab }) {
    const { contingents, setContingents, discountCodes, automaticDiscountCodes, ticketing } = useContext(WidgetContext);
    function decreaseContingent(contingent) {
        Object.assign(contingent, {count: Math.max(0, contingent.count - 1)});
        setContingents([...contingents]);
    }
    
    function increaseContingent(contingent) {
        Object.assign(contingent, {count: Math.max(0, contingent.count + 1)});
        setContingents([...contingents]);
    }

    function setPriceGross(contingent, price_gross) {
        Object.assign(contingent, {price_gross: Math.min(Math.max(contingent.pay_as_you_want_min, price_gross), contingent.pay_as_you_want_max)});
        setContingents([...contingents]);
    }

    let filteredContingents = contingents;
    if (activeTab !== 'all') {
        filteredContingents = filter(contingents, contingent => find(contingent.product_categories, {slug: activeTab}));
    }

    let activeCategory = find(ticketing.product_categories, {slug: activeTab});

    return (
        <div className="p-16 flex-1 overflow-scroll relative">
          <h2 className="text-xl font-bold">{activeCategory.name}</h2>
          <div className="flex flex-row flex-wrap">
            {filteredContingents.length ? 
             filteredContingents.map((contingent, ix) => (
                 <div key={contingent.id} className="flex flex-col items-start w-64 p-4">
                   <div className="font-cooper-hewitt-book mb-1 truncate w-full">{contingent.name}</div>
                   {contingent.picture ? 
                    (
                        <div className="w-full h-72 bg-center bg-cover" style={{backgroundImage: `url(${optimizeImage(contingent.picture, )})`}}/>
                    )
                    : (
                        <div className="w-full h-72 flex justify-center items-center bg-gray-light text-[#aaa]">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                    )
                   }
                   <div className="flex flex-row justify-between w-full pt-2 items-start">
                     {contingent.type === 'pay_as_you_want' ? (
                         <div className="text-mm font-bold">
                              <div>
                                <input
                                  className="w-20 border rounded-full px-2 text-right"
                                  type="number"
                                  value={contingent.price_gross}
                                  onChange={event => setPriceGross(contingent, parseFloat(event.target.value))}
                                  required={true}
                                /> €
                              </div>
                              <div className="flex items-center text-[13px] text-right font-normal leading-[16px]">
                                {toMoney(contingent.pay_as_you_want_min)} - {toMoney(contingent.pay_as_you_want_max)}
                              </div>
                              <div className="font-normal -mb-2 pb-1 leading-[13px] text-[9px]">
                                inkl. {toPercent(contingent.vat_rate)} MwSt.
                              </div>
                            </div>
                        ) : (
                            <div className="pt-[2px] text-mm font-bold">
                              {toMoney(contingent.price_gross)}
                              <div className="font-normal leading-[12px] text-[9px]">
                                inkl. {toPercent(contingent.vat_rate)} MwSt.
                              </div>
                            </div>
                        )}
                     <div className="flex flex-row w-28 justify-between items-center">
                       <button onClick={() => decreaseContingent(contingent)} className="z-10 bg-gold text-white rounded-full w-9 h-9 flex items-center justify-center font-bold text-lg pb-1 pl-0.5">-</button>
                       <div className="-mx-3 flex-1 flex items-center justify-center bg-light_brown h-9 ">{contingent.count}</div>
                       <button onClick={() => increaseContingent(contingent)} className="bg-gold text-white rounded-full w-9 h-9 flex items-center justify-center font-bold text-lg pb-1 pl-0.5">+</button>
                       
                     </div>
                   </div>
                   {contingent.description && <p className="text-sm pt-2">{contingent.description}</p>}
                   {contingent.is_invite_only && <p className="text-red-500 pt-1">Nur mit Code verfügbar</p>}                      
                 </div>
             ))
             : (
                 <div className="text-black">In dieser Kategorie befinden sich derzeit keine Produkte</div>
             )
            }
          </div>
        </div>
    );
}
